/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

( function( app ) {
  const COMPONENT = {
    className: 'll-wl-bag',
    selector: function() {
      return '.' + this.className;
    },
    init: function() {
      // mobile filter toggles
      $( '.wl-bag_mobile-filter-toggle' ).on( 'click', function() {
        $( '.wl-bag_mobile-filter' ).toggleClass( 'bag_active' );
      } );
      $( '.wl-bag_mobile-filter-exit' ).on( 'click', function() {
        $( '.wl-bag_mobile-filter' ).toggleClass( 'bag_active' );
      } );

      // if user arrived to single page by a filtered result, update back link to go back to the filtered result
      if ( $( '.wl-bag-single' ).length > 0 ) {
        let backUrl = localStorage.getItem( 'wlBackToBag' );
        if ( backUrl === null ) {
          backUrl = `/${$( '.wl-bag-single' ).find( '.wl-bag-back-btn' ).attr( 'data-archive' )}/`;
        }
        console.log( backUrl );
        $( '.wl-bag-back-btn' ).attr( 'href', backUrl );
      }

      // if url has parameters, filter the results
      if ( window.location.search ) {
        filterBag( new URLSearchParams( window.location.search ).toString() );
      } else {
        $( '#wl-bag_results-container' ).addClass( 'is-loaded' );
      }

      // Filter Form
      const form = $( '#wl-bag_filter-form' );
      const inputs = $( '.wl-bag_filter-form input' );

      // if a checkbox is changed, update the form and add a pill button showing the new filter
      document.querySelectorAll( '.wl-bag_filter-form input[type="checkbox"]' ).forEach( ( el ) => {
        el.addEventListener( 'change', () => {
          // check to see if changed checkbox has a pill
          // if it does click the pill to remove the item,
          // else create the pill and then submit the form
          const checkboxes = document.querySelectorAll( '.wl-bag_filter-form input[value="'+el.value+'"]' );
          const currentButton = document.querySelector( 'button[value="'+el.value+'"]' );

          if ( currentButton ) {
            currentButton.parentElement.remove();
            if ( !$( '.wl-bag_pill-btn' ).length ) {
              $( '.wl-bag_selected-filters' ).removeClass( 'active' );
            }
            form.trigger( 'submit' );
          } else {
            $( '.wl-bag_selected-filters' ).addClass( 'active' );
            const label = document.querySelector( '[for="' +el.id+'"]' );

            const newContent = `<li class="mx-2 mb-3">
          <button type="button" class="inline-flex items-center p-2 text-xs font-medium rounded bg-brand-dark-brown hover:bg-brand-brown wl-bag_pill-btn" form="wl-bag_filter-form" name="${el.name.replace( '[]', '' )}" value="${el.value}"">
            <span class="sr-only">Remove filter for</span>
            ${label.textContent}
            <svg class="w-2.5 h-2.5 ml-3 text-white pointer-events-none icon icon-cross-small"><use xlink:href="#icon-cross-small"></use></svg>
          </button>
        </li>`;
            document.querySelector( '.wl-bag_selected-filters ul' ).insertAdjacentHTML( 'beforeend', newContent );
          }
          form.trigger( 'submit' );
        } );
      } );

      // when the form is submitted, update browser history and get new results
      form.on( 'submit', function( event ) {
        event.preventDefault();

        const formData = new FormData( event.target );
        const urlQuery = new URLSearchParams( formData ).toString();

        history.replaceState( '', '', '?'+decodeURIComponent( urlQuery ) );
        filterBag( urlQuery );

        const fromUrl = window.location.href;
        localStorage.setItem( 'wlBackToBag', fromUrl );
      } );

      // set up pagination with history
      document.body.addEventListener( 'click', function( event ) {
        const target = event.target;
        if ( target.classList.contains( 'wl-bag-page-numbers', 'wl-bag_filter-tag' ) ) {
          const page = target;
          const urlQuery = new URLSearchParams( window.location.search );
          urlQuery.set( 'page', page.dataset.value );
          history.replaceState( '', '', '?'+decodeURIComponent( urlQuery.toString() ) );
          filterBag( urlQuery.toString() );
          location.href = '#wl-bag_results-container';
        }
      } );

      // When clear all filters is clicked, unset all of the checkboxes, and resubmit the form
      $( '.wl-bag_clear-filter' ).on( 'click', function( e ) {
        e.preventDefault();

        document.querySelectorAll( '.wl-bag_filter-form input[type="checkbox"]' ).forEach( ( el ) => {
          el.checked = false;
        } );

        document.querySelectorAll( '.wl-bag_selected-filters .wl-bag_pill-btn' ).forEach( ( el ) => {
          el.remove();
        } );

        $( '.wl-bag_selected-filters' ).removeClass( 'active' );

        form.trigger( 'submit' );
      } );

      // If there are no pill buttons (i.e. no filters), remove the Clear All Filters button
      if ( $( '.wl-bag_pill-btn' ).length >= 1 ) {
        $( '.wl-bag_clear-filter' ).removeClass( 'hidden' );
      } else {
        $( '.wl-bag_clear-filter' ).addClass( 'hidden' );
      }

      // remove pills when clicked and resubmit form
      $( '.wl-bag_selected-filters' ).on( 'click', '.wl-bag_pill-btn', function( el ) {
        if ( this.classList.contains( 'wl-bag_pill-btn' ) ) {
          const uncheckedInput = document.querySelectorAll( 'input[name="'+this.name+'[]"][value="'+this.value+'"]' );
          $( uncheckedInput ).each( function() {
            $( this )[0].checked = false;
          } );

          const termButton = document.querySelector( 'button[value="'+this.value+'"]' );
          if ( termButton ) {
            termButton.parentElement.remove();
          }

          form.trigger( 'submit' );
        }

        if ( !$( '.wl-bag_pill-btn' ).length ) {
          $( '.wl-bag_selected-filters' ).removeClass( 'active' );
        }
      } );

      // Filter the results with ajax
      function filterBag( query ) {
        $( '#wl-bag_results-container' ).addClass( 'is-filtering' );

        $.ajax( {
          type: 'GET',
          url: siteInfo.wpApiSettings.ll + 'wlbag/filter', // note that articles/filter is the path set in our new route in routes.php
          data: {
            action: 'll_wl-bag_filter',
            query: query,
          },
          beforeSend: function( xhr ) {
            xhr.setRequestHeader( 'X-WP-Nonce', siteInfo.wpApiSettings.nonce );
            xhr.setRequestHeader( 'X-Requested-With', 'XMLHttpRequest' );
            doingAjax = true;
          },
          success: function( data ) {
            if ( data.posts.length ) {
              document.querySelector( '#wl-bag_results-container' ).innerHTML = data.posts.join( '' );
              document.querySelector( '#wl-bag_results-container' ).insertAdjacentHTML( 'afterBegin', '<h2 class="sr-only">Filtered Results:</h2>' );

              if ( data.pagination.length ) {
                document.querySelector( '.wl-bag_pagination' ).outerHTML = data.pagination;
              } else {
                document.querySelector( '.wl-bag_pagination' ).innerHTML = data.pagination;
              }

              if ( $( '.wl-bag_pill-btn' ).length >= 1 ) {
                $( '.wl-bag_clear-filter' ).removeClass( 'hidden' );
              } else {
                $( '.wl-bag_clear-filter' ).addClass( 'hidden' );
              }
            } else {
              document.querySelector( '#wl-bag_results-container' ).innerHTML = '<p class="wl-bag-filter-result-notice mb-12">No results found, please adjust your search</p>';
              document.querySelector( '.wl-bag_pagination' ).innerHTML = '';
            }

            $( '#wl-bag_results-container' ).addClass( 'is-loaded' ).removeClass( 'is-filtering' );
          },
          error: function( err ) {
            console.log( err );
          },
        } );
      }
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'll-wl-bag', COMPONENT );
} )( app );

